import { useSearchParams, useNavigate } from 'react-router-dom';
import { AppList } from '@/components/AppList';
import { DeploymentList } from '@/components/DeploymentList';
import { Button } from '@/components/ui/button';
import { PageHeader } from '@/components/PageHeader';
import { PageTabs } from '@/components/PageTabs';

const tabs = [{ id: 'apps', label: 'Apps' }, { id: 'deployments', label: 'Deployments' }];

export function AppsPage() {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const tab = params.get('tab') === 'deployments' ? 'deployments' : 'apps';
  return (
    <div className="space-y-6">
      <PageHeader title="Apps" description="Deployed applications and their deployment history."
        actions={<Button onClick={() => navigate('/apps/new')}>Deploy new app</Button>}>
        <PageTabs tabs={tabs} active={tab} label="Apps views"
          onSelect={(id) => setParams(id === 'apps' ? {} : { tab: id }, { replace: true })} />
      </PageHeader>
      {tab === 'apps' ? <AppList /> : <DeploymentList />}
    </div>
  );
}
